<script>
const Hero = () => import("@/components/media/Hero.vue");
export default {
  name: "internshipprogram",
  data() {
    return {};
  },
  components: {
    Hero,
  },
  computed: {},
  methods: {
    sendToLogin() {
      this.$store.commit("user/SET_NEXT_ROUTE", { path: "/vagas/378937-programa-de-estagio-rendimento" });
      this.$store.commit("DEVISE_FORM", "login");
    },
  }
};
</script>

<template>
  <section class="internshipprogram">
    <Hero
      title=""
      :image="'estagio.png'"
      height="75vh"
      :search="false"
    />
    <div class="text-hero"><img src="@/assets/images/chamada.png" alt=""></div>
    <div>
      <div class="history">
        <div class="tittle">
          <h1>Transforme</h1><h1 class="t">sua carreira</h1>
        </div>
        <p>Uma das melhores portas de entrada para o futuro profissional, o Programa de Estágio no  Rendimento permite que você pratique o que está estudando e aprenda muito mais.</p>
        <p>Aqui, somando a teoria com a prática, de forma protagonista, você ampliará os horizontes da sua carreira, que está só começando.</p>
        <p class="t2">Partiu futuro?</p>

      </div>

      <div class="row perfil">
        <div class="left"><img src="@/assets/images/perfil-section.png" alt=""></div>
        <div class="right">
          <div class="tittle"><h1>Qual o perfil do</h1><h1 class="t">nosso estagiário?</h1></div>
          <div class="requirements">
            <div><img src="@/assets/images/book-icon.png" alt="book"></div>
            <div><p><strong>Formação:</strong> de acordo com o solicitado pela vaga;</p></div>
          </div>
          <div class="requirements">
            <div><img src="@/assets/images/graduation-icon.png" alt="book"></div>
            <div><p><strong>Graduação:</strong> a partir do 1º ano da faculdade <br> (Disponibilidade mínima de 1 ano para estágio);</p></div>
          </div>
          <div class="requirements">
            <div><img src="@/assets/images/perfil-icon.png" alt="book"></div>
            <div><p><strong>Perfil Rendimento:</strong> ser estudioso, cooperativo, protagonista <br> e apaixonado por tecnologia;​</p></div>
          </div>
          <div class="requirements">
            <div><img src="@/assets/images/map-icon.png" alt="book"></div>
            <div><p><strong>Localização:</strong> Pinheiros/ SP.</p></div>
          </div>
        </div>
      </div>
      <div class="etapas">
        <div class="tittle"><h1>Etapas</h1></div>
        <div class="steps">
          <img src="@/assets/images/etapas.png" alt="etapas">
        </div>
      </div>
      <div class="row journey">
        <div class="jornada"><h1>Jornada de</h1><h1 class="t">desenvolvimento</h1></div>
        <div class="timeline">
          <img src="@/assets/images/timeline.png" alt="timeline">
        </div>
      </div>

      <div class="row beneficios">
        <div><h1>Benefícios</h1></div>
        <div class="icons">
          <div>
            <img src="@/assets/images/icons/icone4.png" alt="beneficios">
            <p>Bolsa Auxilio</p>
          </div>
          <div>
            <img src="@/assets/images/icons/icone5.png" alt="beneficios">
            <p>Vale refeição</p>
          </div>
          <div>
            <img src="@/assets/images/icons/icone4.png" alt="beneficios">
            <p>Seguro de Vida</p>
          </div>
          <div>
            <img src="@/assets/images/icons/icone3.png" alt="beneficios">
            <p>Assistência médica</p>
          </div>
          <div>
            <img src="@/assets/images/icons/icone2.png" alt="beneficios">
            <p>Gympass</p>
          </div>
          <div>
            <img src="@/assets/images/icons/icone.png" alt="beneficios">
            <p>Clube Íris</p>
          </div>
        </div>
      </div>
      <div class="cadastro">
        <div class="c-tittle"><h1>Venha trabalhar</h1><h1 class="d">com a gente</h1></div>
        <div class="c-button">
          <button
            type="button"
            style="border:none"
            @click="sendToLogin()"
          >
          Quero me inscrever
          </button></div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.internshipprogram{
  font-family: 'Bw Gradual DEMO';

  .text-hero{
    img{
      position: absolute;
      margin: -274px 32px;
      width: 80%;

      @include media-breakpoint-down(md){
        margin: -213px 32px;
        width: 100%;
      }

      @include media-breakpoint-down(sm){
        margin: -135px 32px;

      }

    }
  }
    .history{
      text-align: center;
      padding: 60px 280px;
      color: #0A1D6F;
      .tittle{
        font-size: 36px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .t{
          color: #00CFD9;
          margin-left: 10px;
          font-weight: bold;
        }
      }

      p{
        font-size: 17px;
        line-height: 32px;
        font-style: normal;
      }
      .t2{
        color: #00CFD9;
        font-size: 20px;
        font-style: italic;
        font-weight: 600;
      }

      @include media-breakpoint-down(md){
      text-align: center;
      padding: 60px 130px;
      }

      @include media-breakpoint-down(sm){
        padding: 30px ;

        h1{
          font-size: 25px;
        }
      }

    }

    .perfil{
      background: linear-gradient(0deg, rgba(217, 217, 217, 0.2), rgba(217, 217, 217, 0.2)), #FFFFFF;
      display: flex;
      flex-wrap: wrap;
      .left{
        width: 50%;
        img{
          width:100%;
          max-height: 620px;
          object-fit: cover;
        }
      }

      .right{
        margin: 30px 73px;
        color: #0A1D6F;
        .tittle{
          .t{
            color: #00CFD9;
            margin-left: 10px;
            font-weight: bold;
          }
        }

        .requirements{
          display: flex;
          img{
            width: 30px;
          }
          p{
            font-size: 17px;
            margin-left: 3px;
            margin-top: 2px;
          }
        }
      }

      @include media-breakpoint-down(md){
        justify-content: center;
        .left{
          display: none;
        }
        .right{
          .tittle{
            text-align: center;
            margin-bottom: 30px;
          }
          .requirements{
            justify-content: flex-start;
          }
        }
      }

      @include media-breakpoint-down(sm){
        h1{
          font-size: 25px;
        }
      }
    }

    .etapas{
      display: flex;
      flex-direction: column;
      margin-bottom: 70px;

      .tittle{
        text-align: center;
        margin-top: 80px;
        h1{
          color: #0A1D6F;
        }
      }

      .steps{
        text-align: center;
        margin-top: 30px;
        img{
          width: 80%;
        }
      }

      @include media-breakpoint-down(md){
        .tittle{
        margin-top: 20px;
      }

      .steps{
        img{
            width: 100%;
        }
      }
      }

      @include media-breakpoint-down(sm){
        h1{
          font-size: 25px;
        }
      }
    }

    .journey{
      background-color: theme-color('color-1');
      color: #FFFFFF;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .jornada{
       display: flex;
       justify-content: center;
       margin-top: 100px;
        .t{
          color: #00CFD9;
          margin-left: 10px;
        }
      }

      .timeline{
        text-align: center;
        margin: 40px 0 150px 0;
        img{
          width: 80%;
        }
      }

      @include media-breakpoint-down(md){
        .timeline{
          padding: 0 10px;
        margin: 40px 0;
        img{
          width: 100%;
        }
      }
      }

      @include media-breakpoint-down(sm){
        h1{
          font-size: 25px;
        }
      }

    }

    .beneficios{
      display: flex;
      justify-content: center;
      flex-direction: column;
      color: #0A1D6F;
      margin-bottom: 50px;

      div{
        text-align: center;
        h1{
          margin-top: 30px;
        }
      }

      .icons{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        max-width: 1000px;
        text-align: center;
        margin: auto;
        div{
          margin: 30px 50px;
          img{
            width: 80%;
          }
          p{
            font-weight: bold;
          }
        }
      }

      @include media-breakpoint-down(sm){
        margin-bottom: 10px;
        h1{
          font-size: 25px;
        }

        .icons{
          div{
            margin: 17px 9px;
            img{
              width: 50%;
            }
          }
        }
      }
    }

    .cadastro{
      margin-right: -15px;
      margin-left: -15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .c-tittle{
        display: flex;
        color: #0A1D6F;
        justify-content: center;

        .d{
          color: #00CFD9;
          margin-left: 10px;
          font-weight: bold;
        }
      }

      .c-button{
        text-align: center;
        margin-bottom: 80px;
        margin-top: 10px;
        button{
          background-color: theme-color('color-1');
          padding: 6px 30px;
          color: #00CFD9;
          border-radius: 30px;
        }
      }

      @include media-breakpoint-down(sm){
        h1{
          font-size: 25px;
        }
      }
    }


  /deep/ .hero {
    height: 65vh !important;

    @include media-breakpoint-down(md){
    height: 50vh !important;
    }
    @include media-breakpoint-down(sm){
    height: 42vh !important;
    }
  }

}
</style>
